import { CmsBusinessMaturityOption, CmsSignupIntentOption } from 'signup-constants/signupData/CmsOption';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { JobFieldOption } from 'signup-constants/signupData/JobFieldOption';
import { isOptionShufflingDisabled } from '../selenium/seleniumFeatures';
import { Data } from './DATA';

const shuffleArray = function shuffleArray(options) {
  let currentIndex = options.length;
  let randomIndex; // While there remain elements to shuffle.

  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--; // And swap it with the current element.

    [options[currentIndex], options[randomIndex]] = [options[randomIndex], options[currentIndex]];
  }

  return options;
};

const shuffleOptions = function shuffleOptions(options) {
  return isOptionShufflingDisabled() ? options : shuffleArray(options);
};

export const DataOptions = {
  [Data.CompanySize]: Object.values(CompanySizeOption),
  [Data.JobField]: [...shuffleOptions([JobFieldOption.Sales, JobFieldOption.Marketing, JobFieldOption.Support, JobFieldOption.Admin]), JobFieldOption.Other],
  [Data.CrmExperienceLevel]: [CrmExperienceOption.None, CrmExperienceOption.HasUsedCrm, CrmExperienceOption.HasUsedHubSpot],
  [Data.HubInterest]: shuffleOptions([HubInterestOption.Sales, HubInterestOption.CustomerService, HubInterestOption.Marketing, HubInterestOption.CMS]),
  [Data.HubletSelection]: [HubletOption.na1, HubletOption.eu1],
  [Data.CmsSignupIntent]: [CmsSignupIntentOption.Business, CmsSignupIntentOption.Personal],
  [Data.CmsBusinessMaturity]: [CmsBusinessMaturityOption.ExploringIdea, CmsBusinessMaturityOption.ReadyToLaunch, CmsBusinessMaturityOption.RecentlyLaunched, CmsBusinessMaturityOption.EstablishedBusiness],
  [Data.HubOption]: [HubInterestOption.Marketing, HubInterestOption.Sales, HubInterestOption.CustomerService, HubInterestOption.CMS]
};